import label from "@/lang/StaticLabels.js";

export default {
  setting: (state) => {
    return state.setting;
  },
  saleSetting: (state) => {
    return state.saleSetting;
  },

  saleType: (state) => {
    return state.saleType;
  },
  saleTypeById: (state) => {
    return state.saleTypeById;
  },
  saleTypeMaxCode: (state) => {
    return state.saleTypeMaxCode;
  },

  seller: (state) => {
    return state.seller;
  },
  sellerById: (state) => {
    return state.sellerById;
  },
  sellerMaxCode: (state) => {
    return state.sellerMaxCode;
  },

  salesAgents: (state) => {
    return state.salesAgents;
  },
  salesAgentsById: (state) => {
    return state.salesAgentsById;
  },
  salesAgentsMaxCode: (state) => {
    return state.salesAgentsMaxCode;
  },

  salePricePolicy: (state) => {
    return state.salePricePolicy;
  },
  salePricePolicyById: (state) => {
    return state.salePricePolicyById;
  },
  salePricePolicyCommodity: (state) => {
    return state.salePricePolicyCommodity;
  },
  salePricePolicyDetail: (state) => {
    return state.salePricePolicyDetail;
  },
  salePricePolicyDetailById: (state) => {
    return state.salePricePolicyDetailById;
  },
  salePricePolicyMaxCode: (state) => {
    return state.salePricePolicyMaxCode;
  },

  discountPolicy: (state) => {
    return state.discountPolicy;
  },
  discountPolicyById: (state) => {
    return state.discountPolicyById;
  },
  discountPolicyDetail: (state) => {
    return state.discountPolicyDetail;
  },
  discountPolicyDetailById: (state) => {
    return state.discountPolicyDetailById;
  },
  discountPolicyMaxCode: (state) => {
    return state.discountPolicyMaxCode;
  },

  giftPolicy: (state) => {
    return state.giftPolicy;
  },
  giftPolicyById: (state) => {
    return state.giftPolicyById;
  },
  giftPolicyDetail: (state) => {
    return state.giftPolicyDetail;
  },
  giftPolicyDetailById: (state) => {
    return state.giftPolicyDetailById;
  },
  giftPolicyMaxCode: (state) => {
    return state.giftPolicyMaxCode;
  },

  excelSample: (state) => {
    return state.excelSample;
  },
  excelSampleById: (state) => {
    return state.excelSampleById;
  },
  excelSampleDetail: (state) => {
    return state.excelSampleDetail;
  },
  excelSampleData: (state) => {
    return state.excelSampleData;
  },

  preFactor: (state) => {
    return state.preFactor;
  },
  preFactorById: (state) => {
    return state.preFactorById;
  },
  preFactorMaxCode: (state) => {
    return state.preFactorMaxCode;
  },
  preFactorAttachment: (state) => {
    return state.preFactorAttachment;
  },
  preFactorAttachmentById: (state) => {
    return state.preFactorAttachmentById;
  },
  preFactorNotes: (state) => {
    return state.preFactorNotes;
  },

  saleFactor: (state) => {
    return state.saleFactor;
  },
  saleFactorById: (state) => {
    return state.saleFactorById;
  },
  saleFactorId: (state) => {
    return state.saleFactorId;
  },
  saleFactorMaxCode: (state) => {
    return state.saleFactorMaxCode;
  },
  saleFactorAttachment: (state) => {
    return state.saleFactorAttachment;
  },
  saleFactorAttachmentById: (state) => {
    return state.saleFactorAttachmentById;
  },
  saleNotes: (state) => {
    return state.saleNotes;
  },
  saleFactorCommission: (state) => {
    return state.saleFactorCommission;
  },
  saleFactorCommissionById: (state) => {
    return state.saleFactorCommissionById;
  },

  returnSaleFactor: (state) => {
    return state.returnSaleFactor;
  },
  returnSaleFactorById: (state) => {
    return state.returnSaleFactorById;
  },
  returnSaleFactorId: (state) => {
    return state.returnSaleFactorId;
  },
  returnSaleFactorMaxCode: (state) => {
    return state.returnSaleFactorMaxCode;
  },
  returnSaleFactorAttachment: (state) => {
    return state.returnSaleFactorAttachment;
  },
  returnSaleFactorAttachmentById: (state) => {
    return state.returnSaleFactorAttachmentById;
  },
  returnSaleFactorNotes: (state) => {
    return state.returnSaleFactorNotes;
  },
  returnSaleFactorCommission: (state) => {
    return state.returnSaleFactorCommission;
  },
  returnSaleFactorCommissionById: (state) => {
    return state.returnSaleFactorCommissionById;
  },

  saleReportByProduct: (state) => {
    return state.saleReportByProduct;
  },

  salesOfficeReport: (state) => {
    return state.salesOfficeReport;
  },

  saleByAgentReport: (state) => {
    return state.saleByAgentReport;
  },
  saleByAgentDetailReport: (state) => {
    return state.saleByAgentDetailReport;
  },

  salesStatisticsByCustomersReport: (state) => {
    return state.salesStatisticsByCustomersReport;
  },
  salesQuantityReport: (state) => {
    return state.salesQuantityReport;
  },
  customerSalesSingleProductReport: (state) => {
    return state.customerSalesSingleProductReport;
  },
  aggregatedCustomerProductSalesCustomerListReport: (state) => {
    return state.aggregatedCustomerProductSalesCustomerListReport;
  },
  aggregatedCustomerProductSalesCommodityListReport: (state) => {
    return state.aggregatedCustomerProductSalesCommodityListReport;
  },
  customerCommoditySaleReport: (state) => {
    return state.customerCommoditySaleReport;
  },
  customerCommoditySaleFactorListReport: (state) => {
    return state.customerCommoditySaleFactorListReport;
  },
  basedOnSaleManagerListReport: (state) => {
    return state.basedOnSaleManagerListReport;
  },
  basedOnSaleManagerDetailReport: (state) => {
    return state.basedOnSaleManagerDetailReport;
  },
  salesManagerCollaborationPercentageReport: (state) => {
    return state.salesManagerCollaborationPercentageReport;
  },
  reportOfCreditorsAndDebtorsBasedOnSalesManagers: (state) => {
    return state.reportOfCreditorsAndDebtorsBasedOnSalesManagers;
  },
  customerSalesReportBasedOnSalesManagers: (state) => {
    return state.customerSalesReportBasedOnSalesManagers;
  },
  productProfitReport: (state) => {
    return state.productProfitReport;
  },
  grossProfitReport: (state) => {
    return state.grossProfitReport;
  },
  productProfitByProductGroupReport: (state) => {
    return state.productProfitByProductGroupReport;
  },
  grossProfitByInvoiceProductCustomerReport: (state) => {
    return state.grossProfitByInvoiceProductCustomerReport;
  },
  comprehensiveSalesInvoiceReport: (state) => {
    return state.comprehensiveSalesInvoiceReport;
  },
  comprehensiveProductSalesReport: (state) => {
    return state.comprehensiveProductSalesReport;
  },
  awardsGrantedCommodityListReport: (state) => {
    return state.awardsGrantedCommodityListReport;
  },
  awardsGrantedReport: (state) => {
    return state.awardsGrantedReport;
  },
  saleByVisitorList: (state) => {
    return state.saleByVisitorList;
  },
  saleByVisitorReport: (state) => {
    return state.saleByVisitorReport;
  },
  addMinusReport: (state) => {
    return state.addMinusReport;
  },
  customerProfitReport: (state) => {
    return state.customerProfitReport;
  },
  factorProfitReport: (state) => {
    return state.factorProfitReport;
  },

  saleFactorManagementCartable: (state) => {
    return state.saleFactorManagementCartable;
  },
  saleReturnManagementCartable: (state) => {
    return state.saleReturnManagementCartable;
  },

  confirmSaleFactorCartable: (state) => {
    return state.confirmSaleFactorCartable;
  },
  saleFactorGroupDraftCartable: (state) => {
    return state.saleFactorGroupDraftCartable;
  },
  confirmsaleReturnCartable: (state) => {
    return state.confirmsaleReturnCartable;
  },

  cartableLog: (state) => {
    return state.cartableLog;
  },

  printLink: (state) => {
    return state.printLink;
  },

  readPreFactor: (state) => {
    return state.readPreFactor;
  },
  saleFactorVoucher: (state) => {
    return state.saleFactorVoucher;
  },

  readSaleFactor: (state) => {
    return state.readSaleFactor;
  },
  returnSaleFactorVoucher: (state) => {
    return state.returnSaleFactorVoucher;
  },

  returnSaleFactorGroupReceiptCartable: (state) => {
    return state.returnSaleFactorGroupReceiptCartable;
  },

  // Static Getters ---------------------------------------------------------------
  saleFactorActions() {
    return [
      {
        subItems: [
          { value: 1, title: label.button.addAccountingVoucher },
          { value: 2, title: label.button.deleteAccountingVoucher },
        ],
      },
      {
        subItems: [{ value: 8, title: label.button.issueDraft }],
      },
      {
        subItems: [
          { value: 4, title: label.button.copyFactor },
          { value: 5, title: label.button.returnFactor },
          { value: 6, title: label.button.settleFactor },
          { value: 7, title: label.button.cancelFactor },
        ],
      },
      {
        subItems: [{ value: 3, title: label.caption.reReadPreFactor }],
      },
    ];
  },

  returnSaleFactorActions() {
    return [
      {
        subItems: [
          { value: 1, title: label.button.addAccountingVoucher },
          { value: 2, title: label.button.deleteAccountingVoucher },
        ],
      },
      {
        subItems: [{ value: 8, title: label.button.addReceipt }],
      },
      {
        subItems: [
          { value: 4, title: label.button.copyFactor },
          { value: 7, title: label.button.cancelFactor },
        ],
      },
      {
        subItems: [{ value: 3, title: label.caption.reReadSaleFactor }],
      },
    ];
  },
};
